import { CompanyPromotionItemProps } from '@components/ui/listing/PromotionGroup/CompanyPromotionGroupInterface';
import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';
import palette from '@utils/theme/palette';
import Tooltip from '@components/ui/Tooltip/next';

import {
  DesktopPromotionDisplayItemWrapper,
  PromotionNameContainer,
  PromotionNameWrapper,
  DesktopPromotionWrapper,
  LogoWrapper,
  StyledImage,
  TooltipBodyWrapper,
  ShowMoreContainer,
  TooltipItemWrapper,
} from './styled';

const DesktopPromotions = ({
  itemPromotions,
}: {
  itemPromotions: CompanyPromotionItemProps[];
}) => {
  return (
    <DesktopPromotionWrapper>
      <DesktopPromotionDisplayItemWrapper>
        <LogoWrapper
          promotionLogo={itemPromotions?.[0]?.logo?.includes('promotion')}
        >
          <StyledImage
            fill
            src={itemPromotions?.[0]?.logo}
            alt='promotion item'
          />
        </LogoWrapper>
        <PromotionNameWrapper>
          {itemPromotions?.[0]?.description ? (
            <Tooltip
              overlayInnerStyle={{
                textAlign: 'left',
                backgroundColor: palette.NL0,
                padding: '8px',
              }}
              arrowColor={palette.NL0}
              arrowLeft={10}
              overlayStyle={{
                backgroundColor: palette.NL0,
                borderRadius: '8px',
              }}
              placement='bottomLeft'
              title={
                <Typography variant='caption2' weight='Light' color='D500'>
                  {itemPromotions?.[0]?.description}
                </Typography>
              }
              getPopupContainer={(node) => node}
            >
              <CustomIcon paletteColor='NL800' icon={InfoIcon} fontSize={16} />
            </Tooltip>
          ) : (
            <CustomIcon paletteColor='NL800' icon={InfoIcon} fontSize={16} />
          )}
          <PromotionNameContainer>
            <Typography variant='caption3' weight='SemiBold' color='NL800'>
              {itemPromotions?.[0]?.text}
            </Typography>
          </PromotionNameContainer>
        </PromotionNameWrapper>
      </DesktopPromotionDisplayItemWrapper>
      {itemPromotions && itemPromotions.length > 1 ? (
        <Tooltip
          overlayInnerStyle={{
            textAlign: 'left',
            width: '340px',
            backgroundColor: palette.NL0,
            padding: '8px',
          }}
          arrowColor={palette.NL0}
          overlayStyle={{
            backgroundColor: palette.NL0,
            borderRadius: '8px',
          }}
          placement='bottom'
          title={
            <TooltipBodyWrapper>
              {itemPromotions?.slice(1).map((item, index) => (
                <TooltipItemWrapper key={`${item.text}-${index}`}>
                  <LogoWrapper promotionLogo={item.logo.includes('promotion')}>
                    <StyledImage fill src={item.logo} alt='promotion item' />
                  </LogoWrapper>
                  <Typography variant='caption2' weight='Regular' color='D400'>
                    {item.text}
                  </Typography>
                  <Typography variant='caption2' weight='Light' color='D400'>
                    {item.description}
                  </Typography>
                </TooltipItemWrapper>
              ))}
            </TooltipBodyWrapper>
          }
          getPopupContainer={(node) => node}
        >
          <ShowMoreContainer>
            <Typography color='NL800' variant='caption3' weight='Bold'>
              +{itemPromotions.length - 1}
            </Typography>
          </ShowMoreContainer>
        </Tooltip>
      ) : null}
    </DesktopPromotionWrapper>
  );
};

export default DesktopPromotions;
